import { cleanEnv, str } from 'envalid';
import { nodeEnvSpec } from './shared.js';

/**
 * TV environment schema — lazy factory (not evaluated at import time)
 * because build tools (ReNative/webpack) call this at config resolution
 * time, and not all builds need validation.
 */
export const validateTvEnv = () =>
  cleanEnv(process.env, {
    APP_CLIENT: str({ default: 'hoxxtv' }),
    REACT_APP_BRAND: str({ default: '' }),
    // API base override for local/dev stacks (webpack inlines REACT_APP_*).
    // Empty → the app falls back to https://api.<branding.domain>.
    REACT_APP_API_URL: str({ default: '' }),
    NODE_ENV: nodeEnvSpec,
  });
